<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
<app-tool-overlay></app-tool-overlay>
<p-toast></p-toast>
